





















































































import Vue from "vue";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
// import { VContainer } from 'vuetify/lib';
import { BankModule, NavModule, ProfileModule } from "@/store";
import { MediaQuery as MQ } from "@/MediaQuery";
import AvailableBalanceCard from "@/components/banking/AvailableBalanceCard.vue";
import ContributorsCard from "@/components/banking/ContributorsCard.vue";
import FutureFunds from "@/components/banking/FutureFunds.vue";
import ActivityComponent from "@/components/ActivityComponent.vue";
import { User } from "@fgl/funfangle-sdk/dist/rest/profile";
var VueScrollTo = require("vue-scrollto");

@Component({
  components: {
    AvailableBalanceCard,
    ContributorsCard,
    FutureFunds,
    ActivityComponent,
    // VContainer
  }
})
export default class BankDeposits extends Vue {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  isLoaded: boolean = false;
  MQ = MQ;

  get userContributionsByCamper() {
    return this.bankStore.userContributionByCamper;
  }
  get userId() {
    return this.profileStore.userId;
  }
  get person() {
    // TODO Move this somewhere outside of "computed"
    // eslint-disable-next-line
    this.isLoaded = true;
    return this.getAuthorizedPerson(this.$route.params.personId);
  }
  get currentContributors() {
    let userId = 'UNSET';
    if (this.person && this.person !== undefined && this.person.userId !== undefined) {
      userId = this.person.userId;
    }
    let contributors = this.profileStore.contributors.filter(contributor => {
      return contributor.blackListIds?.indexOf(userId || 'UNSET') === -1;
    });
    return contributors;
  }
  // methods: {
  //   ...mapGetters('bank', ['getAuthorizedActivePersons', 'getScheduledAllocations']),
  //   ...mapGetters('user', [
  //     'getUserContributionByCamper',
  //     'getContributors',
  //   ]),
  //   ...mapMutations(['setCurrentPerson']),
  //   ...mapMutations('bank', ['setActiveItem']),
  isValidPerson(person: User) {
    if (person == null) return false;
    // TODO Validation of person object
    return true;
  }
  getAuthorizedPerson(userId: string) {
    // see if the desired user is already stored in the current person object
    if (this.navStore.selectedUserId === userId) {
      return this.navStore.selectedUser;
    }
    // go through each user in the authorized users array
    for (let person of this.profileStore.authorizedActiveUsers) {
      // check if this is the user we're looking for
      if (person.userId === userId) {
        this.navStore.setSelectedUser(person);
        return person;
      }
    }
    // console.warn('did not find user for ', userId)
    return {};
  }
  mounted() {
    // configure open page based on size
    if (MQ.sm) {
      this.navStore.setActiveItem(0);
      // TODO why does it not always scroll to top. Use below temporarily
      VueScrollTo.scrollTo("#content", 500, { offset: -60 });
    }
  }
}
